<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>对账单</el-breadcrumb-item>
            <el-breadcrumb-item>账单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="sunFinance" v-if="bill">
            <el-col :span="6">供应金额：<span>{{bill.order_total}}</span> 元</el-col>
            <el-col :span="6">运费金额：<span>{{bill.express_total}}</span> 元</el-col>
            <el-col :span="6">退款金额：<span>{{bill.refund_total}}</span> 元</el-col>
            <el-col :span="6">
                <el-tag type="warning" v-if="bill.state == 2">待平台审核</el-tag>
                <el-tag type="danger" v-if="bill.state == 3">待平台结算</el-tag>
                <el-tag type="success" v-if="bill.state == 4">完成</el-tag>
                <template v-if="bill.state == 0">
                    <el-tag>已驳回</el-tag>
                    <span class="" style="margin-left: 10px;font-size: 14px">驳回原因：{{bill.reject_reason}}</span>
                </template>
            </el-col>
        </el-row>
        <el-row class="sunFinance" v-if="bill">
            <el-col :span="18">合计：<span>{{bill.order_count}}</span> 单 金额：<span>{{bill.result_totals}}</span> 元</el-col>
            <el-col :span="6"><el-button  type="success" @click="excelOut" size="medium" v-if="bill.state != 0">导出</el-button></el-col>
        </el-row>
        <div style="margin-bottom: 100px" v-if="bill.state == 0">
            <el-card shadow="never">
                <div style="color: red;font-size: 18px">异常订单</div>
            </el-card>
            <table class="table" width="100%" cellpadding="0" cellspacing="0">
                <tr>
                    <th>商品</th>
                    <th>单价/数量</th>
                    <th>总金额</th>
                    <th>来源</th>
                    <th>卖家</th>
                    <th width="120">买家</th>
                    <th width="80">退款金额</th>
                </tr>
                <template v-for="(item, index) in list" v-if="item.is_in_reject == 1">
                    <tr>
                        <th colspan="8">{{item.created_date}} 订单编号：{{item.order_sn}}</th>
                    </tr>
                    <tr v-for="(val , key) in item.goods">
                        <td>
                            <div class="thumb">
                                <img :src="val.pic_url">
                                {{val.product_name}}（{{val.sku_name}}）
                            </div>
                        </td>
                        <template v-if="val.supplier_id > 0">
                            <td>
                                {{val.cost_price}}元/{{val.number}} 件
                            </td>
                            <td>
                                <el-tag size="small">{{val.supplier_cost_price}} 元</el-tag>
                                <br>
                            </td>
                        </template>
                        <template v-else>
                            <td>
                                {{val.supplier_price}}元/{{val.number}} 件
                            </td>
                            <td>
                                <el-tag size="small">{{val.supplier_total_price}} 元</el-tag>
                                <br>
                            </td>
                        </template>
                        <template v-if="!key">
                            <td :rowspan="item.goods.length">
                                {{item.supplier_id ? (item.supplier ? item.supplier.name : '非自营') : '自营'}}
                            </td>
                        </template>
                        <template v-if="!key">
                            <td :rowspan="item.goods.length">
                                {{item.store_id ? (item.store ? item.store.name : '') : ''}}
                            </td>
                        </template>
                        <template v-if="!key">
                            <td :rowspan="item.goods.length">
                                {{item.buyer ? item.buyer.nick_name : ''}}
                                {{item.buyer ? item.buyer.mobile : ''}}
                            </td>
                        </template>
                        <td>
                            <span v-if="val.refund">{{val.refund_money}}</span>
                            <span v-else>0</span>
                        </td>
                    </tr>
                </template>
            </table>
        </div>
        <table class="table" width="100%" cellpadding="0" cellspacing="0">
            <tr>
                <th>商品</th>
                <th>单价/数量</th>
                <th>总金额</th>
                <th>调整金额</th>
<!--                <th>卖家</th>-->
<!--                <th width="120">买家</th>-->
                <th width="80">退款金额</th>
            </tr>
            <template v-for="(item, index) in list">
                <tr>
                    <th colspan="8">{{item.created_date}} 订单编号：{{item.order_sn}}</th>
                </tr>
                <tr v-for="(val , key) in item.goods">
                    <td>
                        <div class="thumb">
                            <img :src="val.pic_url">
                            {{val.product_name}}（{{val.sku_name}}）
                        </div>
                    </td>
                    <td>
                        {{val.cost_price}}元/{{val.number}} 件
                    </td>
                    <td>
                        <el-tag size="small">{{val.supplier_cost_price}} 元</el-tag><br>
                    </td>
                    <td>
                        {{val.supplier_adjust_money}}元
                    </td>
<!--                    <template v-if="!key">-->
<!--                    <td :rowspan="item.goods.length">-->
<!--                        {{item.store_id ? (item.store ? item.store.name : '') : ''}}-->
<!--                    </td>-->
<!--                    </template>-->
<!--                    <template v-if="!key">-->
<!--                    <td :rowspan="item.goods.length">-->
<!--                        {{item.buyer ? item.buyer.nick_name : ''}}-->
<!--                        {{item.buyer ? item.buyer.mobile : ''}}-->
<!--                    </td>-->
<!--                    </template>-->
                    <td>
                        <span v-if="val.refund && val.refund.status == 20">{{val.supplier_cost_price}}</span>
                        <span v-else>0</span>
                    </td>
                </tr>
            </template>
        </table>
    </div>
</template>
<script>
    export default {
        name: 'detail',
        data() {
            return {
                id: this.$route.query.id,
                bill: null,
                list: [],
                isLoad: false
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            loadData: async function () {
                this.isLoad = true
                this.axios.post('supplier/finance/detail',{
                    id: this.id
                }).then(res => {
                    this.isLoad = false
                    this.bill = res.data.detail
                    this.list = res.data.detail.orders2
                }).catch(() => {
                    this.isLoad = false
                }).finally(() => {
                    this.isLoad = false
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            // 导出
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/supplier/finance/detail', {
                    is_export: 1,
                    id: this.id
                })
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '商家对账单详情导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        },

    }
</script>
<style scoped>
    .sunFinance {
        margin-bottom: 20px;
        text-align: center;
    }

    .sunFinance .el-col {
        height: 50px;
        line-height: 50px;
        font-size: 16px;

        border: 1px solid #EBEEF5;
        border-right: none;
    }

    .sunFinance .el-col:last-child {
        border-right: 1px solid #EBEEF5;
    }

    .sunFinance span {
        font-size: 20px;
        color: red;
    }

    .table {
        width: 100%;
        border-collapse: collapse;
    }

    .table td {
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        color: rgb(96, 98, 102);
        line-height: 23px;
    }

    .table th {
        line-height: 23px;
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        text-align: left;
        background: #f5f7fa;
        color: rgb(144, 147, 153);
    }
</style>
